import axios from 'axios';
import config from '@common/common/config';

// Axios 인스턴스 생성
const apiClient = axios.create({
    baseURL: config.apiBaseUrl,
    timeout: 30000, // 30초
    headers: {
        'Content-Type': 'application/json',
        'x-locale': 'ko-KR',
    },
});

export default apiClient;
